addEventListener('DOMContentLoaded', _ => {
    Object.defineProperty(document, 'top', {
        get() {
            return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        },
    })
    const navElement = document.querySelector('#navigation')
    const nextSibling = navElement.parentElement.querySelector('#navigation + *')
    // const mirror = navElement.cloneNode(true)
    // mirror.classList.add('mirror')
    // navElement.parentElement.insertBefore(mirror, nextSibling)
    // addEventListener('scroll', _ => {
    //     if (document.top > navElement.clientHeight) {
    //         navElement.classList.add('scrolled')
    //     } else {
    //         navElement.classList.remove('scrolled')
    //     }
    // })

    const hamburger = document.querySelector('#nav-toggle')
    const navItems = document.querySelector('#navigation-items')
    hamburger.addEventListener('click', _ => {
        navItems.classList.toggle('open')
        hamburger.classList.toggle('opened')
        if (navItems.classList.contains('open')) {
            hamburger.dataset.cannotClose = 1
            setTimeout(_ => hamburger.dataset.cannotClose = 0, 1e3)
        }
    })
    hamburger.addEventListener('mouseover', _ => {
        if (navItems.classList.contains('open') && hamburger.dataset.cannotClose === '0') {
            navItems.classList.toggle('open')
            hamburger.classList.toggle('opened')
        }
    })
    navItems.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', _ => {
            navItems.classList.remove('open')
            hamburger.classList.remove('opened')
        })
    })
})
